<div class="leagueDropDown {{ isOpen ? 'isActive' : ''}}"
     *ngIf="_DATA"
     [style.width]="componentWidthStretch ? '100%' : calculatedComponentWidth +2+ 'px'">
  <div class="upperSelect item dataSize_{{_DATA.length}} selectedItemIndex_{{selectedIndex}}"
       *ngIf="_selectedItem"
       outsideListener
       (clickOutside)="handleOpen($event)"
       [style.width]="componentWidthStretch ? '100%' : componentWidth +2+ 'px'">
    <button class="headerButton {{isBig ? 'big' : '' }}">
      <ng-container *ngIf="prefixIcon">
        <img src="../../../Images/{{_selectedItem.icon}}" class="iconB"/>
      </ng-container>
      <span class="grow {{centeredText ? 'centerText': ''}} tournamentFilter">
        <ng-container *ngIf="isTranslated">
          {{_translate.getT(_selectedItem[displayNameKey])}}
        </ng-container>
        <ng-container *ngIf="!isTranslated && dropdownType==='' ">
          <div class="names">
            <div class="country" [ngClass]="_selectedItem.name == '2-Way' || _selectedItem.name == '2-Weg' ? 'country twoWayTitle' : 'country'">{{_selectedItem[displayNameKey]}}</div>
            <div *ngIf="_selectedItem[altNameKey]" class="tour">{{_selectedItem[altNameKey]}}</div>
          </div>
        </ng-container>
                <ng-container *ngIf="!isTranslated && dropdownType==='sportCategory' ">
          <div class="names">
            <div class="country" [ngClass]="_selectedItem.name == '2-Way' || _selectedItem.name == '2-Weg' ? 'country twoWayTitle' : 'country'">{{_selectedItem[displayNameKey]}}</div>
            <div *ngIf="_selectedItem[altNameKey]" class="tour">{{_selectedItem[altNameKey]}}</div>
          </div>
        </ng-container>
        <ng-container *ngIf="!isTranslated && dropdownType==='leagueCategory' ">
          <div class="names">
            <div class="country" [ngClass]="_selectedItem.name == '2-Way' || _selectedItem.name == '2-Weg' ? 'country twoWayTitle' : 'country'">{{_selectedItem.TournamentName}}</div>
            <div *ngIf="_selectedItem[altNameKey]" class="tour">{{_selectedItem[altNameKey]}}</div>
          </div>
        </ng-container>
      </span>
      <div class="sport-event-count {{getSportCount(_selectedItem.name) == '' ? '' : 'live'}}">
        <p>{{getSportCount(_selectedItem.name)}}</p>
      </div>
      <span class="dropDownArrow" *ngIf="_DATA.length > 1"></span>
    </button>
  </div>
  <div class="itemContainer" *ngIf="_DATA.length != 1">
    <div class="itemInsideWrapper">
      <ng-container *ngFor="let item of _DATA; let k = index">
        <div class="item"
             (click)="handleClick(item,k)"
             [ngClass]=" _selectedItem === item[selectDataKey] ? 'select' : 'unselected'"
             [style.width]="componentWidthStretch ? '100%' : componentWidth +2+ 'px'">

          <button class="headerButton {{centeredText ? 'centerText': ''}}">
            <ng-container *ngIf="isTranslated">
              <ng-container *ngIf="prefixIcon">
                <img src="../../../Images/{{item.icon}}" class="iconB"/>
              </ng-container>
              {{_translate.getT(item[displayNameKey])}}
        <div class="sport-event-count {{getSportCount(item.name) == '' ? '' : 'live'}}">
          <p>{{getSportCount(item.name)}}</p>
        </div>
            </ng-container>
            <ng-container *ngIf="!isTranslated && dropdownType===''">
              <div class="tournamentFilter">
                <ng-container *ngIf="prefixIcon">
                  <img src="../../../Images/{{item.icon}}" class="flag"/>
                </ng-container>
                <div class="names">
                  <div class="country">
                    <div class="text">
                      {{item[displayNameKey]}}
                    </div>
                  </div>
                  <div class="tour">{{item[altNameKey]}}</div>
                </div>
                <div class="count">
                  {{item[tournamentSportEventCount]}}
                </div>

              </div>
            </ng-container>
            <ng-container *ngIf="!isTranslated && dropdownType==='sportCategory'">
              <ng-container *ngIf="prefixIcon">
                <img src="../../../Images/{{item.icon}}" class="iconB"/>
              </ng-container>
              {{item.name}}
        <div class="sport-event-count {{getSportCount(item.name) == '' ? '' : 'live'}}">
          <p>{{getSportCount(item.name)}}</p>
        </div>
            </ng-container>
            <ng-container *ngIf="!isTranslated && dropdownType==='leagueCategory'">
              <div class="tournamentFilter">
                <ng-container *ngIf="prefixIcon">
                  <img src="../../../Images/{{item.icon}}" class="flag"/>
                </ng-container>
                <div class="names">
                  <div class="country">
                    <div class="text">
                      {{item.TournamentName}}
                    </div>
                  </div>
                  <div class="tour">{{item[altNameKey]}}</div>
                </div>
                <div class="count">
                  {{item[tournamentSportEventCount]}}
                </div>

              </div>
            </ng-container>
          </button>
        </div>
      </ng-container>
    </div>
  </div>
</div>

